import { ProcessingIcon } from "@components";

const PaymentProcessing = ({ merchant, children }) => {

  return (<div className="bg-zinc-100 h-dvh grow lg:h-full">
    <div className="w-full  lg:w-[480px] mx-auto flex flex-col items-center">
      <div className="size-[160px] mx-auto flex items-center justify-center mt-10">
        <ProcessingIcon merchant={merchant} />
      </div>
      <h1 className="font-semibold text-xl mb-2">Payment processing</h1>
      <p className="text-zinc-500 text-center">Hold tight, we’re contacting your bank to securely initiate your payment.</p>
      {children}
    </div>
  </div>);
};

export default PaymentProcessing;
